<template lang="html">
  <div class="dropdown">
    <transition name="fade-from-top">
      <div v-if="open" class="options p-md-3 rounded open-up">
        <slot>Dropdown controls not loaded</slot>
      </div>
    </transition>
    <div v-if="open" class="fullscreen"
      @click="$emit('cancel')"
    />
  </div>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
  }
};
</script>

<style lang="scss" scoped>
.options {
  position: absolute;
  min-width: 175px;
  z-index: 9999;
  background: white;
  filter: drop-shadow(0 0 5px hsla(0,0, 0%, 0.5));

  @media screen and (max-width: $breakpoint-sm) {
    position: fixed;
    height: 100%;
    width: 100%;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9999;
  }

  &.open-up {
    transform: translate3d(0, calc(-100% - 35px), 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DropdownContainer.vue